import { debounce } from "../inc/helpers";
import Pqp from "../inc/Pqp";

export default class PageSingleSoluzione {
  constructor() {
    this.data = null;
    this.maxLevels = 3;
    this.observer = null;
  }

  init(data) {
    this.data = data;
    this.init_level_cards();
    this.init_sticky_elems();
  }

  init_level_cards() {
    const icons = document.querySelectorAll(".js-level-icon");
    let offsets = [...Array.from(icons)?.map(i => i.offsetTop), Math.round(window.scrollY)]?.sort((a, b) => a - b);                 
    let j = offsets.indexOf(Math.round(window.scrollY));
    let i = j > 0 ? j : 0;

    // check previous entries
    if (i > 0) {
      let k = i;
      while (k >= 0) {
        icons[k]?.classList.add("is-active");
        k--;
      }
    }

    const handle_scroll = () => {
      const elem = icons[i];
      const start = Math.round(Math.max(elem?.offsetTop, window.innerHeight / 2) - Math.min(elem?.offsetTop, window.innerHeight / 2));

      if (Math.round(window.scrollY) >= start) {
        elem.classList.add("is-active");
        
        if (icons[i + 1]) i++;
      }
    };
    
    window.addEventListener("scroll", handle_scroll);
    window.addEventListener("resize", () => debounce(() => {
      let offsets = [...Array.from(icons)?.map(i => i.offsetTop), Math.round(window.scrollY)]?.sort((a, b) => a - b);                 
      let j = offsets.indexOf(Math.round(window.scrollY));
      let i = j > 0 ? j : 0;

      // check previous entries
      if (i > 0) {
        let k = i;
        while (k >= 0) {
          icons[k]?.classList.add("is-active");
          k--;
        }
      }

      handle_scroll();
    }));

    handle_scroll();
  }

  init_sticky_elems() {
    const sections = Array.from(document.querySelectorAll(".js-sticky-cont"));
    if (!sections) return;

    let nav_h = document.querySelector(".js-site-header")?.offsetHeight;    
    let f_size = parseInt(window.getComputedStyle(document.body).getPropertyValue("font-size")) * 2;
    let i = 0;
    const handle_scroll = () => {
      const s = sections[i];
      const elem = s?.querySelector(".js-sticky-elem");
      const start = s?.offsetTop - nav_h - f_size;
      const stop = start + (s?.offsetHeight - elem?.offsetHeight);      

      if (window.scrollY > stop) {
        elem?.classList.remove("is-sticky");
        elem?.classList.add("is-absolute");
        
        if (sections[i + 1]) i++;
        
      } else if (window.scrollY > start) {
        elem?.classList.remove("is-absolute");

        !elem?.classList.contains("is-sticky")
          && elem.classList.add("is-sticky");        
        
      } else {
        elem?.classList.remove("is-sticky");        
        if (sections[i - 1]) i--;
      }
    };

    window.addEventListener("scroll", handle_scroll);
    window.addEventListener("resize", () => debounce(() => {
      nav_h = document.querySelector(".js-site-header")?.offsetHeight;
      f_size = parseInt(window.getComputedStyle(document.body).getPropertyValue("font-size"));

      handle_scroll();
    }));
    
    handle_scroll();
  }
}
